export const pointInstructions =
  "To manually edit the location, click and drag the marker to a new position. (You will need to save!)";
export const polyInstructions = "Update the overlay position by dragging the image.";
export const signupListItems = [
  "Easily upload your floor plans to a satellite map of your location",
  "Mark the locations of your HVAC units, gas cut-offs, fire extenguishers, and any cricital building asset",
  "Create custom markers and add any type of asset to your building",
  "Allow first responders to have your data in case of emergency",
  "Create step by step instructions so that any building occupant can handle a crisis"
];
export const signupStep2 = {
  trialHead: "What do I get in the trial version?",
  trialText: "",
  freeHead: "Why is it free?",
  freeText:
    "Since MapPlug is new, we are inviting people to try it out for free for a few months so that we can learn how to improve it. We just ask for some honest feedback from you!",
  mainBuildingEntryLabel: "Main building Street Address",
  buildingHelpText:
    "Don't worry about suite numbers or address specifics! You will be able to fine tune your location by dragging a marker to its exact location.",
  afterSignupHead: "What happens after signing up?",
  afterSignupText:
    "After signing up here, you’ll be taken to a map of your location and can start setting up your buildings and assets. Someone will be on Live Chat during work days to help you if you get stuck!"
};



// WEBPACK FOOTER //
// ./src/strings/en-us/text.js